/** CFA program levels this product sells. L1–L3 banks live (Mocks 1–4 each). */
export const CFA_LEVELS = ['l1', 'l2', 'l3'];
export const DEFAULT_LEVEL = 'l1';

export const LEVEL_META = {
  l1: {
    id: 'l1',
    short: 'L1',
    label: 'Level 1',
    path: '/',
    comingSoonPath: null,
    bankReady: true,
    freeMock: true,
  },
  l2: {
    id: 'l2',
    short: 'L2',
    label: 'Level 2',
    path: '/level/2',
    comingSoonPath: null,
    bankReady: true,
    freeMock: true,
  },
  l3: {
    id: 'l3',
    short: 'L3',
    label: 'Level 3',
    path: '/level/3',
    comingSoonPath: null,
    bankReady: true,
    freeMock: true,
  },
};

export function normalizeLevel(value) {
  const raw = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^level[-_\s]*/, '')
    .replace(/^l/, 'l');
  if (raw === '1' || raw === 'l1' || raw === 'level1') return 'l1';
  if (raw === '2' || raw === 'l2' || raw === 'level2') return 'l2';
  if (raw === '3' || raw === 'l3' || raw === 'level3') return 'l3';
  return DEFAULT_LEVEL;
}

export function levelMeta(level) {
  return LEVEL_META[normalizeLevel(level)] || LEVEL_META.l1;
}

export function levelHasFreeMock(level) {
  return levelMeta(level).freeMock === true;
}

export function levelBankReady(level) {
  return levelMeta(level).bankReady === true;
}
